import React from 'react';
import Slider, { Settings } from 'react-slick';
import PrevArrow from '@components/acca/results/common/resultsSlider/prevArrow';
import NextArrow from '@components/acca/results/common/resultsSlider/nextArrow';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const settings: Settings = {
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 3,
  speed: 500,
  draggable: false,
  arrows: true,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  cssEase: 'ease-in-out',
};

interface ResultsSliderProps {
  resultItemEls: any;
}

const ResultsSlider = ({ resultItemEls }: ResultsSliderProps) => {
  return (
    <div className={cx('wrap')}>
      <Slider {...settings}>{resultItemEls}</Slider>
    </div>
  );
};

export default ResultsSlider;
